export const WORKERDEMANDER_TYPES ={
    PROCESS_START:'PROCESS_START',
    PROCESS_SUCCESS :'PROCESS_SUCCESS',
    PROCESS_FAIL :'PROCESS_FAIL',
     
}